import { useEffect, useState } from "react";

function useHasScrollbar() {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    // Enable scrollbars on the body
    document.body.style.overflow = "scroll";

    // Calculate scrollbar width
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    // Check if scrollbar width is greater than 0
    setHasScrollbar(scrollbarWidth > 0);

    // Reset overflow style
    document.body.style.overflow = "";

    // Cleanup function
    return () => {
      document.body.style.overflow = "";
    };
  }, []); // Run only once on component mount

  return hasScrollbar;
}

export { useHasScrollbar };
